// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { ReactElement, memo } from 'react';

interface ImagePreviewProps {
    src: string;
    title?: string;
    alt?: string;
    className?: string;
}

export const ImagePreview = memo(
    ({ src, title = '', alt = '', className }: ImagePreviewProps): ReactElement => (
        <img
            src={src}
            className={classList('ImagePreview', className)}
            title={title}
            alt={alt}
            role="presentation"
            loading="lazy"
        />
    ),
);
